<!-- 环形图 -->
<template>
  <div class="fund-ring-chart"
    :style="{ alignItems: $isEmpty(dataSource) ? 'center' : 'flex-start'}">
    <div >
      <canvas :id="chartId" :style="chartSize"></canvas>
    </div>
    <!-- 图例 -->
    <fund-hold-legend
      v-if="!$isEmpty(dataSource)"
      :data-source="dataSource"
      :cur-tab="curTab"
      :is-more-than-hundred="isMoreThanHundred || false" />
    <div v-else class="empty-content">
      {{`暂无${curTab.name || ''}分布数据`}}
    </div>
  </div>
</template>

<script>
import F2 from '@antv/f2';
import FundHoldLegend from './FundHoldLegend.vue';

export default {

  name: 'fund-ring-chart',

  components: { FundHoldLegend },

  props: {
    chartId: {
      type: String,
      default: 'pie-chart',
    },
    dataSource: {
      type: Array,
      default: () => ([]),
    },
    showLegend: {
      type: Boolean,
      default: false,
    },
    polarHtml: {
      type: String,
      default: '',
    },
    chartSize: {
      type: Object,
      default: () => ({}),
    },
    curTab: {
      type: Object,
      default: () => ({}),
    },
    isMoreThanHundred: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    // 初始化图标
    initChart() {
      const chart = new F2.Chart({
        id: this.chartId,
        pixelRatio: window.devicePixelRatio,
        appendPadding: 0,
        padding: 0,
      });
      // console.log('🌈', this.dataSource, this.curTab);
      chart.source(this.dataSource); // 数据源
      chart.tooltip(false); // 展示提示信息
      const map = {};
      const colorMap = {};
      this.dataSource.forEach((obj) => {
        map[obj.type] = `${(obj.percent * 100).toFixed(2)}%`;
        colorMap[obj.type] = obj.color;
      });
      chart.legend(this.showLegend ? {
        position: 'right',
        itemFormatter: function itemFormatter(val) {
          return `${val}    ${map[val]}`;
        },
      } : false);
      chart.coord('polar', { // 坐标系 polar-极坐标系 rect-直角坐标系
        transposed: true,
        innerRadius: 0.75,
        radius: 1,
      });
      chart.axis(false); // 不渲染坐标轴
      chart.interval()
        .position('a*percent')
        .color('type', (type) => colorMap[type])
        .adjust('stack'); // stack | dodge
      chart.guide().html({ // 辅助信息
        position: ['50%', '50%'],
        html: this.polarHtml,
      });
      if (this.$isEmpty(this.dataSource)) { // 数据源为空
        chart.guide().arc({
          start: [0, 0],
          end: [1, 99.99999],
          top: false,
          style: {
            lineWidth: 18,
            stroke: '#f6f7fb',
          },
        });
      }
      chart.render();
    },
  },
};
</script>

<style lang="less" scoped>
.fund-ring-chart {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  .empty-content {
    margin-left: 30px;
    font-size: 30px;
    text-align: center;
    color: #999999;
  }
}
</style>
